/* action type */
export const OPEN_WORK_BY_HANDLE = 'OPEN_WORK_BY_HANDLE';

/* action creator */
export const openWorkByHandleAction = (actionPayload: { [key: string]: any }) => {
  return {
    type: OPEN_WORK_BY_HANDLE,
    payload: actionPayload
  };
};
